<template>
    <div>
        <div class="position-relative">
            <tsoft-table
                :name="'finance-request'"
                :key="componentRefreshKey"
                :api="tableApiUrl"
                :items.sync="items"
                :isNeedSearch="isNeedSearch"
                :isNeedCreate="isNeedCreate"
                :additionalGetParameter="additionalGetParameter"
                :typeOfTableFilter="'finance-requests'"
                :onDataEmptyMessage="'Финансовые запросы отсутствуют. Создайте счет, и сможете добавить к нему запрос.'"
                :headerContextMenuName="'financeRequestsTable'"
                @show="showItem"
                @edit="createOrEditItemModal"
                @delete="deleteItem"
                @changeFinanceRequestStatus="changeFinanceRequestStatus"
            />
            <b-overlay
                :show="dataOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </div>

        <tsoft-create-finance-request
            v-if="createFinanceRequestFlag"
            :finance_id="createRequestObject.finance_id"
            :order_id="createRequestObject.order_id"
            :company_id="createRequestObject.company_id"
            :order_service_id="createRequestObject.order_service_id"
            @close="closeFinanceRequest"
        ></tsoft-create-finance-request>

    </div>
</template>

<script>
    import { API_FINANCE_REQUESTS, API_POST_FINANCE_REQUEST_NOTIFICATIONS_READ_BY_CREATOR_USER_ID } from '@/constants'
    import tsoftCreateFinanceRequest from './CreateFinanceRequest'

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        changeCommasOnDots,
    } from '@/mixins'

    const initialEditedItem = () => ({
        id: '',
        creator_user_id: '',
        for_user_id: '',
        finance_id: '',
        order_id: '',
        order_service_id: '',
        company_id: '',
        comment: '',
        reference_type_id: '',
        reference_status_id: '',
        type_of_request: '',            // auto field with type of request name
        operation_generation: '',       // auto filed with operation text generation by incoming parameters
        status: '',                     // auto field with status of request name
    })

    export default {
        components: {tsoftCreateFinanceRequest},
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            changeCommasOnDots
        ],
        props: {
            isNeedSearch: { type: Boolean, default: false },                        // If table needs search panel
            isNeedCreate: { type: Boolean, default: false },                        // If table needs create button
            createRequestObject: { type: Object, required: false },                 // For creation request component
            additionalGetParameter: { type: String, default: '' },                  // If we want to add something, for example, &order_id=10
        },
        data() {
            return {
                tableApiUrl: API_FINANCE_REQUESTS,
                createFinanceRequestFlag: false,
                componentRefreshKey: 0,
            }
        },
        watch: {
            '$route.params.user_id': function() {
                this.clearUserRequestsNotificationsList(this.$route.params.user_id);
                this.componentRefreshKey += 1;
            },
        },
        mounted() {
            this.editedItem = initialEditedItem()
            this.dataOverlay = false
            if (this.$route.params.user_id) {
                this.clearUserRequestsNotificationsList(this.$route.params.user_id)
            }
        },
        methods: {
            createOrEditItemModal() {
                this.createFinanceRequestFlag = true
            },
            closeFinanceRequest() {
                this.createFinanceRequestFlag = false
                this.componentRefreshKey += 1
            },
            changeFinanceRequestStatus(index, status_id) {
                this.dataOverlay = true
                let id = this.items.data[index].id
                let updateFields = {
                    reference_status_id: status_id,
                    end_comment: ''
                }

                // we ask for stay comment
                this.$swal.fire({
                    title: 'Не хотите отправить ответное сообщение?',
                    input: 'textarea',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    cancelButtonText: 'Нет',
                    confirmButtonText: 'Отправить',
                    showLoaderOnConfirm: true,
                    preConfirm: (endComment) => {
                        updateFields.end_comment = endComment
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                }).then((result) => {
                    api.call("put", `${this.tableApiUrl}/${id}`, updateFields).then(({data}) => {
                        Object.assign(this.items.data[index], data)
                        this.dataOverlay = false
                    })
                }).finally(() => {
                    this.makeToast('info', 'Статус изменен')
                })
            },
            modalTitle() {
                let title = 'Добавление нового запроса'
                if (this.editIndex > -1) {
                    title = 'Редактирование запроса #' + this.editedItem.id
                }

                return title
            },
            clearUserRequestsNotificationsList: async function(creator_user_id) {
                if (creator_user_id === 'agents') {
                    // Для агентов очищаем уведомления всех агентов
                    const response = await api.call('post', API_POST_FINANCE_REQUEST_NOTIFICATIONS_READ_BY_CREATOR_USER_ID + `/agents`)
                } else {
                    const response = await api.call('post', API_POST_FINANCE_REQUEST_NOTIFICATIONS_READ_BY_CREATOR_USER_ID + `/${creator_user_id}`)
                }
                this.$store.dispatch('GET_NOTIFICATIONS')
            },
        }
    }
</script>
